import React, { useEffect, useState } from 'react';
import styles from './Styles/DiagnosticAPage.module.css';
import Introduction from './ComponentsDiagnosticA/Introduction';
import preguntas from './ComponentsDiagnosticA/Questions';
import TextoIntermedio from './ComponentsDiagnosticA/TextoIntermedio';
import EndOfDiagnostic from './ComponentsDiagnosticA/EndOfDiagnostic';
import Stepper from './../Stepper/Stepper';
import { db } from '../../firebaseConfig';
import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';
import { useDiagnostico } from '../../context/DiagnosticoContext/DiagnosticoHook';
import { FarewellDiagnosis } from './ComponentsDiagnosticA/FarewellDiagnosis';

const DiagnosticAPage = () => {
  const {
    changeStateShowIntermediateTextFn,
    navigation: { showIntroduction, showIntermediateText, endOfDiagnostic },
    queryDiagnosticA: { data },
    setLoadingTextFn,
    loadingChart,
    idQuestionsFn,
  } = useDiagnostico();

  const [indiceGrupoActual, setIndiceGrupoActual] = useState(0);
  const [cuestionarioFinalizado, setCuestionarioFinalizado] = useState(false);
  const [respuestas, setRespuestas] = useState(
    preguntas.map((seccion) =>
      seccion.grupo.map((pregunta) => ({
        ...pregunta,
        respuesta: pregunta.respuesta,
      })),
    ),
  );
  const [dataChart, setDataChart] = useState([]);
  const [currentAnswer, setCurrentAnswer] = useState([]);
  const [grupoActualCompleto, setGrupoActualCompleto] = useState(false);
  const [sliderIsMoving, setSliderIsMoving] = useState(
    preguntas.map((item, index) => {
      return {
        typeOfGroup: index,
        Answers: item.grupo.map(() => false),
      };
    }),
  );

  useEffect(() => {
    if (showIntermediateText) {
      // Ejecutar lógica cuando aparece el texto intermedio
      // Utilizando el valor actual de `indiceGrupoActual` para determinar qué preguntas mostrar
      const numeroPregunta = indiceGrupoActual;

      const resultadosPorPregunta = obtenerDatosPorPregunta(
        numeroPregunta,
        data?.data ?? [],
      );
      const userResponses = respuestas[indiceGrupoActual]?.map(
        (resp) => resp.respuesta,
      );

      setCurrentAnswer(userResponses);
      setDataChart(resultadosPorPregunta);
    }
  }, [showIntermediateText]);

  useEffect(() => {
    const grupoCompleto = sliderIsMoving
      .find((item) => item.typeOfGroup === indiceGrupoActual)
      .Answers.every((answer) => answer === true);
    setGrupoActualCompleto(grupoCompleto);
  }, [indiceGrupoActual, sliderIsMoving]);

  const obtenerDatosPorPregunta = (numeroPregunta, data) => {
    const respuestasFiltradas = data
      .flatMap((item) => {
        const respuestas = item.respuestas;
        // Asegúrate de que los objetos existen antes de intentar acceder a `respuesta`
        const pregunta0Resp = respuestas[`pregunta${numeroPregunta}_0`]
          ? respuestas[`pregunta${numeroPregunta}_0`].respuesta
          : undefined;
        const pregunta1Resp = respuestas[`pregunta${numeroPregunta}_1`]
          ? respuestas[`pregunta${numeroPregunta}_1`].respuesta
          : undefined;

        return {
          pregunta0: pregunta0Resp,
          pregunta1: pregunta1Resp,
        };
      })
      .filter(
        (res) => res.pregunta0 !== undefined && res.pregunta1 !== undefined,
      );
    return respuestasFiltradas;
  };

  const guardarRespuestasEnFirestore = async () => {
    const userId = uuidv4();
    const idQuestion = uuidv4();
    // Preparar la estructura de las respuestas
    const respuestasObj = {};
    respuestas.forEach((grupoRespuestas, indiceGrupo) => {
      grupoRespuestas.forEach((respuesta, indicePregunta) => {
        const clavePregunta = `pregunta${indiceGrupo}_${indicePregunta}`;
        respuestasObj[clavePregunta] = {
          pregunta: respuesta.pregunta,
          respuesta: respuesta.respuesta,
        };
      });
    });

    const documentoRespuesta = {
      userId,
      timestamp: serverTimestamp(),
      respuestas: respuestasObj,
    };

    try {
      await setDoc(doc(db, 'Respuestas', idQuestion), documentoRespuesta);
      idQuestionsFn(idQuestion);
    } catch (error) {
      console.error('Error al guardar las respuestas: ', error);
    }
  };
  const handleChangeSlider = (indiceGrupo, indicePregunta, nuevoValor) => {
    const valorNumerico = Number(nuevoValor);
    let nuevasRespuestas = [...respuestas];
    nuevasRespuestas[indiceGrupo][indicePregunta].respuesta = valorNumerico;
    setRespuestas(nuevasRespuestas);

    const nuevosSliderIsMoving = sliderIsMoving.map((item) => {
      if (item.typeOfGroup === indiceGrupo) {
        // Crear una copia de Answers y modificar el valor en el índice correspondiente
        let newAnswers = [...item.Answers];
        newAnswers[indicePregunta] = true;

        // Devolver un nuevo objeto con los valores modificados
        return { ...item, Answers: newAnswers };
      } else {
        // Si no es el grupo que estamos buscando, devolver el item sin modificar
        return item;
      }
    });
    setSliderIsMoving(nuevosSliderIsMoving);

    // verificarGrupoCompleto();
  };

  const handleChangeInput = (indiceGrupo, indicePregunta, nuevoValor) => {
    let nuevasRespuestas = [...respuestas];
    nuevasRespuestas[indiceGrupo][indicePregunta].respuesta = nuevoValor;

    let newInputIsChanged = sliderIsMoving.map((item) => {
      if (item.typeOfGroup === indiceGrupo) {
        let newAnswers = [...item.Answers];
        newAnswers[indicePregunta] = true;
        return { ...item, Answers: newAnswers };
      } else {
        return item;
      }
    });

    setSliderIsMoving(newInputIsChanged);
    setRespuestas(nuevasRespuestas);
  };

  const nextPageFn = () => {
    if (cuestionarioFinalizado) {
      return;
    }
    if (showIntermediateText) {
      if (indiceGrupoActual >= preguntas.length - 1) {
        setCuestionarioFinalizado(true); // Marcar el cuestionario como finalizado
        guardarRespuestasEnFirestore(); // Guardar respuestas en Firestore antes de finalizar
      } else {
        setIndiceGrupoActual(indiceGrupoActual + 1);
        changeStateShowIntermediateTextFn(false);
      }
    } else {
      changeStateShowIntermediateTextFn(true);
    }
  };

  const backPageFn = () => {
    if (
      showIntroduction ||
      (indiceGrupoActual === 0 && !showIntermediateText)
    ) {
      return;
    }
    if (showIntermediateText) {
      changeStateShowIntermediateTextFn(false);
    } else if (indiceGrupoActual > 0) {
      changeStateShowIntermediateTextFn(true);
      setIndiceGrupoActual((prev) => prev - 1);
    }
  };
  if (endOfDiagnostic) {
    return <FarewellDiagnosis />;
  }

  if (showIntroduction) {
    return <Introduction setIndiceGrupoActual={setIndiceGrupoActual} />;
  }

  const preguntasLength = preguntas.length - 1;
  const arrayBasadoEnPreguntas = Array.from(
    { length: preguntasLength },
    (_, index) => index + 1,
  );

  return (
    <div className={styles.container}>
      {cuestionarioFinalizado ? (
        <EndOfDiagnostic respuestasDB={data?.data ?? []} /> //Si el cuestionario finalizo
      ) : (
        <div>
          {indiceGrupoActual !== 0 && (
            <Stepper
              steps={arrayBasadoEnPreguntas}
              currentStep={indiceGrupoActual - 1}
            />
          )}

          {showIntermediateText ? (
            <TextoIntermedio
              textoPosicionY={preguntas[indiceGrupoActual]?.textoPosicionY}
              textoPosicionX={preguntas[indiceGrupoActual]?.textoPosicionX}
              texto={preguntas[indiceGrupoActual]?.textoIntermedio}
              dataChart={dataChart}
              currentAnswer={currentAnswer}
              indiceGrupoActual={indiceGrupoActual}
            />
          ) : (
            preguntas[indiceGrupoActual]?.grupo.map(
              (pregunta, indicePregunta) => (
                <div key={indicePregunta} className={styles.containerQuestion}>
                  <h3>{pregunta.title ? pregunta.title : null}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: pregunta.pregunta ? pregunta.pregunta : null,
                    }}
                  />

                  {pregunta.tipo === 'input' ? (
                    <input
                      type="text"
                      placeholder={pregunta.placeholder || ''}
                      value={
                        respuestas[indiceGrupoActual][indicePregunta].respuesta
                      }
                      onChange={(e) =>
                        handleChangeInput(
                          indiceGrupoActual,
                          indicePregunta,
                          e.target.value,
                        )
                      }
                    />
                  ) : pregunta.tipo === 'range' ? (
                    <>
                      <div className={styles.sliderContainer}>
                        <input
                          type="range"
                          value={
                            respuestas[indiceGrupoActual][indicePregunta]
                              .respuesta
                          }
                          min={pregunta.min}
                          max={pregunta.max}
                          onChange={(e) =>
                            handleChangeSlider(
                              indiceGrupoActual,
                              indicePregunta,
                              e.target.value,
                            )
                          }
                          className={styles.rangeSlider}
                          id={`slider-${indiceGrupoActual}-${indicePregunta}`}
                        />
                        <div
                          className={styles.sliderValue}
                          id={`slider-value-${indiceGrupoActual}-${indicePregunta}`}
                          style={{
                            left: `${
                              ((respuestas[indiceGrupoActual][indicePregunta]
                                .respuesta -
                                pregunta.min) /
                                (pregunta.max - pregunta.min)) *
                              100
                            }%`,
                          }}
                        >
                          {
                            respuestas[indiceGrupoActual][indicePregunta]
                              .respuesta
                          }{' '}
                          {indiceGrupoActual !== 1 && '%'}
                        </div>
                      </div>

                      <div className={styles.columnsRange}>
                        <span className={styles.textLeft}>
                          {pregunta.textMin}
                        </span>

                        <span className={styles.textRight}>
                          {pregunta.textMax}
                        </span>
                      </div>
                    </>
                  ) : pregunta.tipo === 'select' ? (
                    <select
                      className={styles.select}
                      value={
                        respuestas[indiceGrupoActual][indicePregunta].respuesta
                      }
                      onChange={(e) =>
                        handleChangeInput(
                          indiceGrupoActual,
                          indicePregunta,
                          e.target.value,
                        )
                      }
                    >
                      <option value="">Selecciona una opción</option>
                      {pregunta.opciones.map((opcion, indiceOpcion) => (
                        <option key={indiceOpcion} value={opcion}>
                          {opcion}
                        </option>
                      ))}
                    </select>
                  ) : null}
                </div>
              ),
            )
          )}

          <div className="botones-contenedor">
            {' '}
            {indiceGrupoActual !== 0 && (
              <button
                className={`btn btn-back btn-comenzar ${!preguntas[indiceGrupoActual].textButtom && 'btn-next'}`}
                onClick={backPageFn}
              >
                <span className="material-icons">arrow_back</span>
                {'Atrás'}
              </button>
            )}
            <button
              className={`btn btn-primary btn-comenzar ${!preguntas[indiceGrupoActual].textButtom && 'btn-next'}`}
              onClick={() => {
                nextPageFn();
                setLoadingTextFn(false);
              }}
              disabled={
                (!grupoActualCompleto && indiceGrupoActual !== 0) ||
                (indiceGrupoActual !== 0 &&
                  showIntermediateText &&
                  !loadingChart)
              }
            >
              {preguntas[indiceGrupoActual].textButtom
                ? preguntas[indiceGrupoActual].textButtom
                : 'Siguiente'}
              <span className="material-icons">arrow_forward</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
export default DiagnosticAPage;
